import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/sysLog/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/sysLog/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/sysLog/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/sysLog/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/sysLog/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/sysLog/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/sysLog/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/sysLog/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/sysLog/update/batch',
    method: 'POST',
    data})
}

   